export type SeedState = 'deciding' | 'preparing' | 'blocked'

const SEED_STATES: Record<string, SeedState> = {
  seed_deciding: 'deciding',
  seed_preparing: 'preparing',
  seed_audio_unavailable: 'blocked',
}

export const seedStateOf = (reason: string | null | undefined): SeedState | null =>
  (reason && SEED_STATES[reason]) || null

export const isSeedPending = (reason: string | null | undefined): boolean => {
  const state = seedStateOf(reason)
  return state === 'deciding' || state === 'preparing'
}
